import { render, staticRenderFns } from "./modalAddNotificationTypesSetup.vue?vue&type=template&id=505e1656&"
import script from "./modalAddNotificationTypesSetup.vue?vue&type=script&lang=js&"
export * from "./modalAddNotificationTypesSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports